import { SIDEBAR_STATUS } from "@constants";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: SIDEBAR_STATUS.FULL,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: { data: initialState, loading: false },
  reducers: {
    updateStatus(state, action) {
      state.data = {
        ...state.data,
        status: action.payload,
      };
    },
  },
});

const { actions, reducer } = sidebarSlice;

const sidebarActions = actions;
const sidebarReducer = reducer;

export { sidebarActions, sidebarReducer };
